import { baseApi } from "./baseApi";

const COMMUNICATION_BASE_URL = "/communications"

export const communicationApi = baseApi.injectEndpoints({
    tagTypes: ["Communication"],

    endpoints: (builder) => ({
        addCommunication: builder.mutation({
            query: (payLoad) => ({
                url: COMMUNICATION_BASE_URL,
                method: "POST",
                body: payLoad
            }),
            invalidatesTags: (_result, _error, { _id }) => [
                { type: "Communication", id: _id },
                { type: "Communication", id: "LIST" },
            ],
        }),

        listCommunication: builder.query({
            query: (params) => ({
                url: COMMUNICATION_BASE_URL,
                params,
            }),
            providesTags: (result) =>
                result?.data
                    ? [
                        ...result?.data?.map(({ _id }) => ({ type: "Communication", _id })),
                        { type: "Communication", id: "LIST" },
                    ]
                    : [{ type: "Communication", id: "LIST" }],
        }),

        getDDLCommunicationList: builder.query({
            query: (params) => ({ url: `${COMMUNICATION_BASE_URL}/ddl`, params }),
            providesTags: (result) =>
                result?.data
                    ? [
                        ...result?.data?.map(({ _id }) => ({ type: "Communication", _id })),
                        { type: "Communication", id: "DDL" },
                    ]
                    : [{ type: "Communication", id: "DDL" }],
        }),

        getCommunicationDetail: builder.query({
            query: (Id) => `${COMMUNICATION_BASE_URL}/${Id}`,
            providesTags: (_result, _error, { _id }) => [
                { type: "Communication", _id },
                { type: "Communication", id: "LIST" },
            ],
        }),

        updateCommunication: builder.mutation({
            query: ({ _id, ...body }) => ({
                url: `${COMMUNICATION_BASE_URL}/${_id}`,
                method: "PUT",
                body,
            }),
            invalidatesTags: (_result, _error, { _id: id }) => [
                { type: "Communication", id },
                { type: "Communication", id: "LIST" },
            ],
        }),
    })
})

export const {
    useAddCommunicationMutation,
    useListCommunicationQuery,
    useLazyListCommunicationQuery,
    useLazyGetDDLCommunicationListQuery,
    useGetCommunicationQuery,
    useGetCommunicationDetailQuery,
    useUpdateCommunicationMutation,
} = communicationApi;